import React from "react";
// import loginBg from "../assets/images/login-bg.svg";
import loginBg2 from "../assets/images/login-bg.png";
import Close from "../assets/images/X.svg";

export default function ErrorMessage({ onClick, error }) {
  return (
    <div className="leap-relative !leap-z-[9999]">
      <img
        src={loginBg2}
        alt="loginBg"
        className="leap-h-[10rem] md:leap-h-[20rem] leap-w-[45rem]  md:leap-w-[32rem] xl:leap-w-[55rem] leap-z-[9999]"
      />
      <div className="leap-z-[9999] leap-scale-75 md:leap-scale-105  leap-absolute leap-top-1/2 -leap-translate-x-[50%] -leap-translate-y-[50%] leap-left-1/2 leap-gap-5">
        {/* custom-white-border */}
        <h1 className="!leap-z-[9999] leap-text-[30px] sm:leap-text-2xl lg:sm:leap-text-3xl leap-my-3 leap-font-bold  leap-text-center leap-uppercase leap-text-white">
          {error}
        </h1>
      </div>
      <button className="" onClick={onClick}>
        <img
          src={Close}
          alt="Close"
          className="leap-absolute  leap-top-[8px]  leap-left-[8px]  leap-w-6 leap-h-6  md:leap-w-8 md:eap-h-8"
        />
      </button>
    </div>
  );
}
